import * as React from "react";
import * as moment from "moment";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import {
    AdjustQuickJournalSystemDateTime,
    ClearQuickJournalSystemDateTimeOverride,
    GetQuickJournalNow,
    GetQuickJournalSystemDateTimeOverride,
    SetQuickJournalSystemDateTimeOverride,
} from "source/app/presentation/BottomBar/QuickJournal/Data/Clock/QuickJournalClock";
import { useQuickJournalSystemClockVersion } from "source/app/presentation/BottomBar/QuickJournal/Hooks/useQuickJournalSystemClockVersion";

export function QuickJournalClock() {
    const clockVersion = useQuickJournalSystemClockVersion();
    const [draftValue, setDraftValue] = React.useState(() =>
        FormatForDateTimeLocalInput(GetQuickJournalNow())
    );

    React.useEffect(() => {
        setDraftValue(FormatForDateTimeLocalInput(GetQuickJournalNow()));
    }, [clockVersion]);

    const currentOverride = GetQuickJournalSystemDateTimeOverride();
    const currentLabel = currentOverride
        ? moment(GetQuickJournalNow()).format("YYYY-MM-DD HH:mm")
        : "Real time";

    const actionIconStyleClass = StyleClass(`quickJournalClockAction`, {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "18px",
        opacity: 0.72,
    });

    return (
        <div style={{ margin: "10px 0", fontSize: "12px", opacity: 0.82 }}>
            <div style={{ marginBottom: "6px" }}>QuickJournal time</div>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                <input
                    type="datetime-local"
                    value={draftValue}
                    onChange={(event) => setDraftValue(event.target.value)}
                    style={{
                        background: "rgba(0, 0, 0, 0.22)",
                        color: "inherit",
                        border: "1px solid rgba(255, 255, 255, 0.18)",
                        borderRadius: "6px",
                        padding: "3px 6px",
                        fontFamily: "monospace",
                        fontSize: "11px",
                        lineHeight: "1.2",
                    }}
                />
                <Hyperlink
                    whenClicked={() => SetQuickJournalSystemDateTimeOverride(draftValue)}
                    classes={actionIconStyleClass}
                    tooltip="Set exact time"
                >
                    <Glyphicon icon={EGlyphicon.ok} />
                </Hyperlink>
                <Hyperlink
                    whenClicked={() => AdjustQuickJournalSystemDateTime(-1, "hours")}
                    classes={actionIconStyleClass}
                    tooltip="Back one hour"
                >
                    <Glyphicon icon={EGlyphicon.minus} />
                </Hyperlink>
                <Hyperlink
                    whenClicked={() => AdjustQuickJournalSystemDateTime(1, "hours")}
                    classes={actionIconStyleClass}
                    tooltip="Forward one hour"
                >
                    <Glyphicon icon={EGlyphicon.plus} />
                </Hyperlink>
                <Hyperlink
                    whenClicked={() => AdjustQuickJournalSystemDateTime(-1, "days")}
                    classes={actionIconStyleClass}
                    tooltip="Back one day"
                >
                    <Glyphicon icon={EGlyphicon["chevron-left"]} />
                </Hyperlink>
                <Hyperlink
                    whenClicked={() => AdjustQuickJournalSystemDateTime(1, "days")}
                    classes={actionIconStyleClass}
                    tooltip="Forward one day"
                >
                    <Glyphicon icon={EGlyphicon["chevron-right"]} />
                </Hyperlink>
                <Hyperlink
                    whenClicked={() => ClearQuickJournalSystemDateTimeOverride()}
                    classes={actionIconStyleClass}
                    tooltip="Return to real time"
                >
                    <Glyphicon icon={EGlyphicon.refresh} />
                </Hyperlink>
            </div>
            <div style={{ marginTop: "6px", opacity: 0.72 }}>
                Current: {currentLabel}
            </div>
        </div>
    );
}

function FormatForDateTimeLocalInput(date: Date): string {
    return moment(date).format("YYYY-MM-DDTHH:mm");
}
